import { Button, Menu, MenuItem, Tooltip, Typography, Link } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import IconButton from '@material-ui/core/IconButton';
import PrintIcon from '@material-ui/icons/Print';
import { createStyles, makeStyles, Theme, useTheme } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import LoadIcon from '@material-ui/icons/CloudDownload';
import { default as LogoutIcon, default as OutputIcon } from '@material-ui/icons/ExitToApp';
import MenuIcon from '@material-ui/icons/Menu';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import SaveIcon from '@material-ui/icons/Save';
import VideoLibraryIcon from '@material-ui/icons/VideoLibrary';
import OverwriteIcon from '@material-ui/icons/SaveAlt';
import ResetIcon from '@material-ui/icons/Undo';
import clsx from 'clsx';
import merge from 'deepmerge';
import React, { useState } from 'react';
import { isBrowser } from 'react-device-detect';
import { useGlobal } from 'reactn';
import { IGlobalState, IMyAppState, initialState, initialStateBudget, initialStateSimulazioniSrl } from '../states/GlobalState';
import { getElaborazione, sovrascriviElaborazione } from '../services/api';
import SchedaBudgetDataClass from '../states/BudgetState';
import { SimulazioniSrlDataClass } from '../states/SimulazioneSrlState';
import Auth, { clearIdentityFromStorage, saveHideLoginInSession } from '../types/auth';
import { Applicazioni } from '../types/types';
import { drawerWidth, breakpoint  } from '../types/constants';
import CaricaElaborazione from '../components/CaricaElaborazione';
import { CustomDialog } from '../dialog/CustomDialog';
import SalvaElaborazione from '../components/SalvaElaborazione';
import VideoTutorial from '../video/VideoTutorial';
import { useHistory } from "react-router-dom";
import Drawer from '../drawer/drawer';
import DrawerMobile from '../drawer/drawerMobile';
import { getLicenseNumber } from '../services/principalService';
import { SectionAlert } from '../components/SectionAlert';

export type AppBarProps = {
  title: string;
  handleLoad: any;
  handleChange?: any;    // to change Tab
  handleChangeApplicazione?: any;  // to change application from a number to another
  // leftMenuOpenClosed: any;
  // saveState: any;
  loadState?: any;
  resetState?: any;
  // applicazione: number;
  // configuration: VariabiliConfig;
  stateIForfetari?: IMyAppState | null;
  stateSimSrl?: SimulazioniSrlDataClass | null;
  stateSkBudget?: SchedaBudgetDataClass | null;
  apptabs?: string[];
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'row',
      flex: '1 1 auto'
    },
    appBar: {
      borderBottom: "2px solid",
      boxShadow: "none",
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      // marginRight: theme.spacing(2),
    },
    hide: {
      display: 'none',
    },
    buttonIcon: {
      margin: "1rem",
      cursor: "pointer"
    },
    logoBar: {
      flex: 1,
      display: 'flex',
      alignItems: 'center'
    }
  }),
);

export default function IForfettariAppBar(props: AppBarProps) {
  const classes = useStyles();
  const [application,] = useGlobal<IGlobalState, 'application'>('application');
  const [companies,] = useGlobal<IGlobalState, 'companies'>('companies');
  const [drawerIsOpen, setDrawerIsOpen] = useGlobal<IGlobalState, 'drawerIsOpen'>('drawerIsOpen');
  const [drawerMobileIsOpen, setDrawerMobileIsOpen] = useGlobal<IGlobalState, 'drawerMobileIsOpen'>('drawerMobileIsOpen');
  const [salvaOpened, setSalvaOpened] = React.useState(false);
  const [overwriteOpened, setOverwriteOpened] = React.useState(false);
  const [caricaOpened, setCaricaOpened] = React.useState(false);
  const [dialogOpened, openDialog] = useState<boolean>(false);
  const [helpOpened, setHelpOpened] = useState<boolean>(false);
  const [showOverwrite, setShowOverwrite] = React.useState(false);
  const [auth] = useGlobal<IGlobalState, 'auth'>('auth');
  const [ip] = useGlobal<IGlobalState, 'ip'>('ip');
  const [identity, ] = useGlobal<IGlobalState, 'identity'>('identity');
  const [licenseNumber, setLicenseNumber] = useGlobal<IGlobalState, 'licenseNumber'>('licenseNumber');
  const [global] = useGlobal<IGlobalState>();
  const history = useHistory();
  const [state, setState] = useState({ mobileView: false});
  const { mobileView } = state;
  let prov = Auth.getProvincia(global);
  let username = Auth.getUsername(global);
  
  function handleDrawerMobileOpen() {
    // setOpen(true);
    setDrawerMobileIsOpen(true);
  }
  
  function handleDrawerOpen() {
    // setOpen(true);
    setDrawerIsOpen(!drawerIsOpen);
  }

  function handleClickReset() {
    openDialog(true);
  }

  function handleClickSalva() {
    setSalvaOpened(true);
  }

  function handleClickSovrascrivi() {
    setOverwriteOpened(true);
  }

  function handleClickCarica() {
    setCaricaOpened(true);
  }

  // function quit() {
  //   // window.location.replace("quit.html");
  //   window.opener = null;
  //   window.open("", "_self");
  //   window.close();  
  // }

  function onClose() {
      setTimeout(function() {
          // window.location.replace("quit.html");
          // window.top.close()
          // window.parent.close()
          window.opener = null;
          window.open('', '_self');
          window.close();
          }, 
          1000
      )    
  }
  
  function handleClickLogout() {    
    // console.log('Close Top the browser child ' + window.location)
    // window.opener=null;
    // window.top.close()    
    // window.parent.close()
    // window.close()
    clearIdentityFromStorage();
    
    if (identity?.Company && identity?.Company?.LogoutUrl !== null && identity?.Company?.LogoutUrl !== '') {
      console.log('Close the browser ')
      // window.open('about:blank', "_self", '');
      // console.log('Close Top the browser newname ' + window.location.toString())
      auth.user = null;
      console.log('Close Top the browser child ' + window.location)
      // window.location.replace("quit.html");
      saveHideLoginInSession();
      // auth.userManager.signoutRedirect(identity?.Company?.LogoutUrl!);
    } 
    auth.userManager.signoutRedirect();
  }

  function handleCloseSalva() {
    setSalvaOpened(false);
  }

  function handleCloseCarica() {
    setCaricaOpened(false);
  }

  function handleClickShowVideo() {
    setHelpOpened(true);
  }

  function handleLoad(id: number) {
    props.handleLoad("setLoading", "", true);
    getElaborazione(prov!, username, id, global).then(elab => {
      let newStateLoad;
      let newState;
      if (application === 1) {
        newStateLoad = elab.State as IMyAppState;
        newState = merge(initialState, newStateLoad);
      }
      else if (application === 2) {
        newStateLoad = elab.State as SimulazioniSrlDataClass;
        newState = merge(initialStateSimulazioniSrl, newStateLoad);
      }
      else if (application === 3) {
        newStateLoad = elab.State as SchedaBudgetDataClass;
        newState = merge(initialStateBudget, newStateLoad);
      }

      newState.id = id;
      props.loadState(newState, application);
      setCaricaOpened(false);
      props.handleLoad("setLoading", "", false);
      setShowOverwrite(true);
    });
  }

  function handleDelete(id: number) {
    setCaricaOpened(false);
  }

  function handleClose() {
    openDialog(false);
  }

  function handleCloseHelp() {
    setHelpOpened(false);
  }

  function handleOk() {
    props.resetState();
    openDialog(false);
  }

  function handleCloseOverwrite() {
    setOverwriteOpened(false);
  }

  function handleOkOverwrite() {
    var id = 0;
    var state;
    if (application === Applicazioni.iForfettari) {
      id = (props.stateIForfetari as IMyAppState).id;
      state = props.stateIForfetari;
    }
    else if (application === Applicazioni.ConvSrl) {
      id = (props.stateSimSrl as SimulazioniSrlDataClass).id;
      state = props.stateSimSrl;
    }
    else if (application === Applicazioni.Budget4u) {
      id = (props.stateSkBudget as SchedaBudgetDataClass).id;
      state = props.stateSkBudget;
    }
    props.handleLoad("setLoading", "", true);
    sovrascriviElaborazione(prov!, username, id, JSON.stringify(state), global).then(elab => {
      setOverwriteOpened(false);
      props.handleLoad("setLoading", "", false);
    });
  }

  const logoDaUsare = () => {

    const company = companies.find(x => x.Id === identity?.CompanyId);

    // require(window.location.host.includes("unappa-") ? 
    //                 "../images/logo_unappa.png" : 
    //                 window.location.host.includes("wki-") ? "../images/logo_wki.png" : "../images/logo_Sixtema_Bianco.png").default;
    return require(`../images/${company?.UiLogoUrl ?? 'logo_Sixtema_Bianco.png'}`).default;
  }

  const logoMobileDaUsare = () => {
    
    const company = companies.find(x => x.Id === identity?.CompanyId);
    
    // require(window.location.host.includes("unappa-") ? "../images/logo_unappa.png" : 
    //   window.location.host.includes("wki-") ? "../images/logo_wki_mobile.png" : "../images/logo_Sixtema_Bianco_mobile.png").default;
    return require(`../images/${company?.UiLogoUrl ?? 'logo_Sixtema_Bianco.png'}`).default;
  } 
  
  
  const appNameToUse = () => {
    let result: string = '';
    const company = companies.find(x => x.Id === identity?.CompanyId);
    
    // result = window.location.host.includes("wki-") ? "SimulTax" : "ConsulTool";
    result = 'ConsulTool';
    if (company)
      result = company!.ApplicationName;
    return result;
  }

  const getRole = () => {
    return global && global.identity ? global.identity!.Role : "";
  } 

  const getActiveLicenses = async () => {
    let licenses = await getLicenseNumber(ip, auth.authData!, auth.user!, identity?.Id);
    setLicenseNumber(licenses);
  }
  
  const getImageName = () => {
    let result: string = '';

    if (application === Applicazioni.iForfettari) result = "Forfetari"; 
    if (application === Applicazioni.ConvSrl) result = "Convenienza Srl";
    if (application === Applicazioni.Budget4u) result = "Budget4u";
    if (application === Applicazioni.Company) result = "Gestione company";
    if (application === Applicazioni.Agency) result = "Gestione studi"; 
    if (application === Applicazioni.Principal) result = "Gestione utenti";
    if (application === Applicazioni.WhatsNew) result = "Gestione what's new";
    if (application === Applicazioni.ImportTelematico) result = "Import Telematico";
    if (application === Applicazioni.Report) result = "Report";
    
    return result;
  }

  const getImageNameWki = () => {
    let result: string = '';

    if (application === Applicazioni.iForfettari) result = "Convenienza Forfetario"; 
    if (application === Applicazioni.ConvSrl) result = "Convenienza Srl";
    if (application === Applicazioni.Budget4u) result = "Simulazione carico fiscale";
    if (application === Applicazioni.Company) result = "Gestione company";
    if (application === Applicazioni.Agency) result = "Gestione studi"; 
    if (application === Applicazioni.Principal) result = "Gestione utenti";
    if (application === Applicazioni.WhatsNew) result = "Gestione what's new";
    if (application === Applicazioni.ImportTelematico) result = "Import Telematico";
    if (application === Applicazioni.Report) result = "Report";
    
    return result;
  }
  
  React.useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < breakpoint
        ? setState((prevState) => ({ ...prevState, mobileView: true }))
        : setState((prevState) => ({ ...prevState, mobileView: false }));
    };
    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());
    getActiveLicenses();
  }, []);
  return (
    <React.Fragment>
      <SalvaElaborazione isOpen={salvaOpened} handleClose={handleCloseSalva} state={application === 1 ? props.stateIForfetari : application === 2 ? props.stateSimSrl : application === 3 ? props.stateSkBudget : props.stateIForfetari}></SalvaElaborazione>
      <CaricaElaborazione isOpen={caricaOpened} handleClose={handleCloseCarica} handleLoad={handleLoad} handleDelete={handleDelete}></CaricaElaborazione>
      <CustomDialog handleClose={handleCloseOverwrite} handleOk={handleOkOverwrite} open={overwriteOpened} title="Conferma sovrascrittura" message="Sei sicuro di procedere con la sovrascrittura dell'eleaborazione corrente? Il salvataggio sostituirà i dati salvati in precedenza."></CustomDialog>
      <CustomDialog handleClose={handleClose} handleOk={handleOk} open={dialogOpened} title="Conferma reset" message="Sei sicuro di procedere con il reset dei campi? Eventuali modifiche non salvate verrano perse."></CustomDialog>
      <VideoTutorial isOpen={helpOpened} handleClose={handleCloseHelp} handleLoad={handleLoad} handleDelete={handleDelete} ></VideoTutorial>
      <div className={classes.root}>
        <CssBaseline />
        <AppBar
          // style={{display:displayAppBar}}
          position="fixed"
          className={clsx(classes.appBar, {
            [classes.appBarShift]: drawerIsOpen && isBrowser,
          })}
        > 
          {/* variant="dense" only desktop */}
          <Toolbar style={{ maxHeight: "60px", minHeight: '60px' }}>
            <IconButton
              id='drawer'
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              className={clsx(drawerIsOpen && classes.hide)}
            >
              <MenuIcon />
            </IconButton>
            {!mobileView ? 
            <button style={{backgroundColor: 'Transparent', backgroundRepeat:'no-repeat', border: 'none', overflow: 'hidden', outline: 'none', cursor: 'pointer'}}>
              <img style={{ height: "2rem"}} alt="" src={logoDaUsare()} onClick={() => {history.push('/')}}/>
              {/* <Typography style={{ fontSize: "8px" }} variant="body2">v.{appNameToUse()} v.{Auth.getVersion()}</Typography> */}
            </button>
            :
            <div style={{display: 'flex', flex: '0 1 auto', flexDirection: 'column'}} onClick={() => {history.push('/')}}> 
              <img style={{ width: "150px", height: '40px'}} alt="" src={logoMobileDaUsare()} />
              <Typography style={{ fontSize: "8px" }} variant="body2">{identity?.Company?.BusinessName} {appNameToUse()} v.{Auth.getVersion()}</Typography>
            </div>
            }
            {!mobileView ? 
            <div style={{display: 'flex', flex: '0 1 auto', flexDirection: 'column'}}>
              <Typography style={{ fontSize: "1.5rem" }} variant="h4">{appNameToUse()}</Typography>
              <Typography style={{ fontSize: "8px" }} variant="body2">{identity?.Company?.BusinessName} v.{Auth.getVersion()}</Typography>
            </div>
            : null}
            {application !== Applicazioni.ConvSrl ?
            <>
              &nbsp;
            </>
            : null}
            {appNameToUse() !== "SimulTax" ?
              (
              <React.Fragment>
                {/* White Label*/}
                <img style={{ height: '2.8rem' }} alt="" title={getImageName()} src={
                  application === Applicazioni.iForfettari ? require('../images/iForfe_new.png').default :
                  application === Applicazioni.ConvSrl ? require('../images/convsrl.png').default :
                  application === Applicazioni.Budget4u ? require('../images/sk_budget.png').default :
                  application === Applicazioni.Company ? require('../images/company.png').default :
                  application === Applicazioni.Agency ? require('../images/agencyWhite.png').default :
                  application === Applicazioni.Principal ? require('../images/users.png').default :
                  application === Applicazioni.WhatsNew ? require('../images/Whats_New_180.png').default : 
                  application === Applicazioni.ImportTelematico ? require('../images/telematico_new.png').default : 
                  application === Applicazioni.Report ? require('../images/report.png').default : 
                  mobileView ? null : logoDaUsare
                } />
                {!mobileView &&
                <>
                &nbsp; 
                <Typography variant="h5" style={{ color: "white", fontSize: "1rem" }}>
                  {application === Applicazioni.iForfettari ? "Forfetari" : 
                    application === Applicazioni.ConvSrl ? "Convenienza Srl" : 
                    application === Applicazioni.Budget4u ? "Budget4u" : 
                    application === Applicazioni.Company ? "Gestione company" : 
                    application === Applicazioni.Agency ? "Gestione studi" : 
                    application === Applicazioni.Principal ? "Gestione utenti" : 
                    application === Applicazioni.WhatsNew ? "Gestione what's new" : 
                    application === Applicazioni.ImportTelematico ? "Import Telematico" : 
                    application === Applicazioni.Report ? "Gestione Report" : 
                    ""}
                </Typography>
                {/* {(application === Applicazioni.iForfettari || application === Applicazioni.ConvSrl || application === Applicazioni.Budget4u) &&
                  <div style={{display: 'flex', marginLeft: '2rem', marginBottom: '0.5rem'}}>
                    <SectionAlert text="Applicazione in manutenzione" mobile={mobileView}></SectionAlert> 
                  </div>
                } */}
                </>
                }
              </React.Fragment>
              )
            :            
            (
              <React.Fragment>
                {/* WKI */}
                <img style={{ height: '2.8rem' }} alt="" title={getImageNameWki()} src={
                    application === Applicazioni.iForfettari ? require('../images/iForfe_new.png').default :
                    application === Applicazioni.ConvSrl ? require('../images/convsrl.png').default :
                    application === Applicazioni.Budget4u ? require('../images/sk_budget.png').default :
                    application === Applicazioni.Company ? require('../images/company.png').default :
                    application === Applicazioni.Agency ? require('../images/agencyWhite.png').default :
                    application === Applicazioni.Principal ? require('../images/users.png').default :
                    application === Applicazioni.WhatsNew ? require('../images/Whats_New_180.png').default : 
                    application === Applicazioni.ImportTelematico ? require('../images/telematico_new.png').default : 
                    application === Applicazioni.Report ? require('../images/report.png').default : 
                    mobileView ? null : logoDaUsare
                  } />
                {!mobileView && 
                <>
                &nbsp; 
                <Typography variant="h5" style={{ color: "white", fontSize: "1rem" }}>
                  {application === Applicazioni.iForfettari ? "Convenienza forfetario" : 
                    application === Applicazioni.ConvSrl ? "Convenienza srl" : 
                    application === Applicazioni.Budget4u ? "Simulazione carico fiscale" : 
                    application === Applicazioni.Company ? "Gestione company" : 
                    application === Applicazioni.Agency ? "Gestione studi" : 
                    application === Applicazioni.Principal ? "Gestione utenti" : 
                    application === Applicazioni.WhatsNew ? "Gestione what's new" : 
                    application === Applicazioni.ImportTelematico ? "Import Telematico" : 
                    application === Applicazioni.Report ? "Gestione Report" : 
                    ""}
                </Typography>
                {/* {(application === Applicazioni.iForfettari || application === Applicazioni.ConvSrl || application === Applicazioni.Budget4u) &&
                  <div style={{display: 'flex', marginLeft: '2rem', marginBottom: '0.5rem'}}>
                    <SectionAlert text="Applicazione in manutenzione" mobile={mobileView}></SectionAlert> 
                  </div>
                } */}
                </>
                }
              </React.Fragment>
            )
            }
            {!mobileView && application <= Applicazioni.Budget4u ?
            <div style={{display: 'flex', flexDirection: 'row', flex: '1 1 auto'}}>
              <Tooltip title="Stampa">
                <PrintIcon className={classes.buttonIcon} onClick={() => window.print()} style={{ marginLeft: "auto" }}></PrintIcon>
              </Tooltip>
              <Tooltip title="Reimposta elaborazione">
                <ResetIcon className={classes.buttonIcon} onClick={handleClickReset}></ResetIcon>
              </Tooltip>
              <Tooltip title="Salva elaborazione">
                <SaveIcon className={classes.buttonIcon} onClick={handleClickSalva}></SaveIcon>
              </Tooltip>
              <Tooltip title="Sovrascrivi elaborazione">
                <OverwriteIcon className={classes.buttonIcon} style={{display: showOverwrite? "": "none"}} onClick={handleClickSovrascrivi}></OverwriteIcon>
              </Tooltip>
              <Tooltip title="Carica elaborazione">
                <LoadIcon className={classes.buttonIcon} onClick={handleClickCarica}></LoadIcon>
              </Tooltip>
              <Tooltip title="Help">
                <VideoLibraryIcon className={classes.buttonIcon} onClick={handleClickShowVideo}></VideoLibraryIcon>
              </Tooltip>
            </div>
            :
            !mobileView && (application === Applicazioni.Principal || application === Applicazioni.ImportTelematico) ?
            <div style={{display: 'flex', flexDirection: 'row', flex: '1 1 auto'}}>
              <Tooltip title="Help">
                <VideoLibraryIcon className={classes.buttonIcon} onClick={handleClickShowVideo} style={{ marginLeft: "auto" }}></VideoLibraryIcon>
              </Tooltip>
            </div>
            :
            null}
            {!mobileView ?
            <>
            <div style={{display: 'flex', marginLeft: 'auto', flex: '0 1 auto', flexDirection: 'column'}}>
              <Typography variant="subtitle1" style={{ marginLeft: "2vw" }}>{"Ruolo: " + getRole()}</Typography>
              {identity?.Company?.IsFederated === false ? 
              <Typography variant="subtitle1" style={{ marginLeft: "2vw" }}>{'Licenze attive: ' + licenseNumber}</Typography>
              : null
              }
            </div>
            <div style={{display: 'flex', flex: '0 1 auto', flexDirection: 'column'}}>
              <Typography variant="subtitle1" style={{ marginLeft: "2vw" }}>{identity?.Company?.BusinessName} - {identity?.PrincipalAuth[0]?.Agency?.Name}</Typography>
              <Typography variant="subtitle1" style={{ marginLeft: "2vw" }}>{identity?.Username}</Typography>
            </div>
            <Tooltip title="Esci">
              <LogoutIcon className={classes.buttonIcon} onClick={handleClickLogout}></LogoutIcon>
            </Tooltip>
            </>
            : 
            (
            <>
              <div style={{display: 'flex', marginLeft: 'auto', flex: '0 1 auto', flexDirection: 'column'}}>
                <Typography variant="subtitle1" style={{ fontSize: '9px', marginLeft: "0px" }}>{identity?.Company?.BusinessName} - {identity?.PrincipalAuth[0]?.Agency?.Name}</Typography>
                <Typography variant="subtitle1" style={{ fontSize: '9px', marginLeft: "0px" }}>{identity?.Username}</Typography>
              </div>
              <div style={{display: 'flex', flex: '0 1 auto', flexDirection: 'row', alignItems: 'flex-end'}}> 
              <IconButton
                id='mobileDrawer'
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerMobileOpen}
                edge="end"              
                className={clsx(drawerMobileIsOpen && classes.hide)}
              >
                <MenuBookIcon />
              </IconButton>
              <DrawerMobile handleClickReset={handleClickReset} handleExit={handleClickLogout} print={window.print} handleClickCarica={handleClickCarica}
                handleClickSalva={handleClickSalva} handleClickShowVideo={handleClickShowVideo} handleClickSovrascrivi={handleClickSovrascrivi} showOverwrite={showOverwrite}/>
              </div>
            </>
            )
            }
          </Toolbar>
        </AppBar>
        <Drawer apptabs={props.apptabs} handleChange={props.handleChange} handleChangeApplicazione={props.handleChangeApplicazione}/>
      </div>
    </React.Fragment>
  );
}
